(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("BrInput", [], factory);
	else if(typeof exports === 'object')
		exports["BrInput"] = factory();
	else
		root["BrInput"] = factory();
})(window, function() {
return 